import React from 'react';
import '../template-file-css/document-file-template.css';



export const HFI_PsRightsNotificationForm = ({
    itemsRef,
    showErrorFor,

}) => {

    return (
        <form id='HFI_PsRightsNotificationForm' className='file-pdf-document'>
            <div className='file-template'>
                <p className='w-750'><center><h3>Rights of Person Served Notification</h3></center></p>

                <table>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Name</span></td>
                        <td className='w-375'>
                            <span className='eleHeader'>Record #</span></td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='text' id='txtName' name='txtName' className='add-only' /></td>
                        <td className='w-375'>
                            <input type='text' id='txtRecord' name='txtRecord' className='add-only' /></td>
                    </tr>
                </table>

                <p className='w-750'>As a recipient of services at our facility, we would like to inform you of your rights as a patient. The information contained in this
                    brochure explains your rights and the process of complaining if you believe your rights have been violated. <br /><br />
                    <b><u>YOUR RIGHTS</u></b></p>

                <table>
                    <ol>
                        <li>Right to a humane treatment or habilitation environment that affords reasonable protection from harm, exploitation, and coercion.</li>
                        <li>Right to be free from physical and verbal abuse</li>
                        <li>Right to freedom from retaliation, humiliation, and neglect.</li>
                        <li>Right to be free from the use of physical restraints and seclusion unless it is determined that there are no less restrictive methods of controlling behavior to reasonably
                            ensure the safety of the person served and other persons</li>
                        <li>Right to informed consent or refusal or expression of choice and withdrawal of consent regarding service delivery, release of information, concurrent services, composition of the service delivery team and involvement in research
                            guidelines/projects/ethics when they are involved if applicable.</li>
                        <li>Right to access or referral to legal entities for appropriate representation, self-help support and advocacy services</li>
                        <li>Right to be informed about plan of treatment and to participate in the planning, as able.</li>
                        <li>Right to be promptly and fully informed of any changes in the plan of treatment.</li>
                        <li>Right to accept or refuse treatment, unless it is determined through established authorized legal process that the
                            person served is unable to care for self or is dangerous to self.</li>
                        <li>1Right to be fully informed of the charges for treatment</li>
                        <li>Right to confidentiality of person served records.<b>9.05 Confidentiality and Release of Information for person Served</b></li>
                        <li>Right to have and retain personal property which does not jeopardize the safety of the person served or other person served or staff and have such property treated with respect.</li>
                        <li>Right to converse privately; have convenient and reasonable access to the telephone and mails, and to see visitors, unless denial is necessary for treatment and the reasons are documented in the person served treatment plan.</li>
                        <li>Right to be informed of the program's complaint policy and procedures and the right to submit complaints without fear of discrimination or retaliation and to have them investigated by the program within a reasonable period of time.</li>
                        <li>Right to have access to and view pertinent information in their own person served records and to obtain copies of their record, unless the physician or other authorized staff feels it is not in persons served best interest.</li>
                        <li>Right to receive a written notice of the address and telephone number of that state licensing authority, i.e. the department, which further explains the responsibilities of licensing the program and investigating person served complaints which appear to violate licensing rules.</li>
                        <li>Right to obtain a copy of the program's most recent completed report of licensing inspection from the program upon written request. The program is not required to release a report until the program has had the opportunity to file a written plan of correction for the violations as provided for in these rules.</li>
                        <li>Right to have all oral and written complaints addressed and resolved as appropriate in a timely manner.</li>

                    </ol>
                </table>

                <p className='w-750'><b><u>YOUR RIGHTS TO RECEIVE INFORMATION</u></b></p>

                <table>
                    <ol>
                        <li>Medications used in your treatment. We will provide you with information describing any potential risks of medications prescribed at our facility.</li>
                        <li>Costs of services. We will inform you of how much you will pay.</li>
                        <li>Termination of services. You will be informed as to what behaviors or violations could lead to ¬termination of services at our organization.</li>
                        <li>Confidentiality. You will be informed of the limits of confidentiality and how your protected health information will be used,</li>
                        <li>Policy changes.</li>
                    </ol>
                </table>

                <p className='w-750'><b><u>OUR ETHICAL OBLIGATIONS</u></b></p>

                <table>
                    <ol>
                        <li>We dedicate ourselves to serving the best interest of each person served.</li>
                        <li>We will not discriminate between person served or professionals based on age, race, creed, disabilities, handicaps, preferences, or other personal concerns.</li>
                        <li>We maintain an objective and professional relationship with each person served.</li>
                        <li>We respect the rights and views of other mental health professionals.</li>
                        <li>We will appropriately end services or refer person served to other programs when appropriate.</li>
                        <li>We will evaluate our personal limitations, strengths, biases, and effectiveness on an ongoing basis for the purpose of self-improvement. We will continually attain further education and training.</li>
                        <li>We respect various institutional and managerial policies but will help to improve such policies if the best interest of the person served is served.</li>
                    </ol>
                </table>

                <p className='w-750'><b><u>YOUR RESPONSIBILITIES</u></b></p>


                <table>
                    <ol>
                        <li>You are responsible for your financial obligations to the organization as outlined in the Payment Contract for Services</li>
                        <li>You are responsible for following the policies of the organization.</li>
                        <li>You are responsible to treat staff and fellow patients in a respectful, cordial manner in which their rights are not violated.</li>
                        <li>You are responsible to provide accurate information about yourself.</li>
                    </ol>

                </table>

                <p className='w-750'><b><u>WHAT TO DO IF YOU BELIEVE YOUR RIGHTS HAVE BEEN VIOLATED</u></b> <br />
                    You are encouraged to ask questions about your services and your rights
                    If you believe that your patient rights have been violated, contact our Recipient's Rights Advocates or speak to our Organizational Director or you may send your concerns in writing to the appropriate advocates: <br />
                    Heritage Foundation, Inc. P.O. Box 2966, Thomasville, Georgia 31799. <br /><br />
                    I have received a copy of the Rights of Persons Served Notification and understand my rights. </p>

                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Name (please print)</span></td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='text' id='txtNamePleasePrint' name='txtNamePleasePrint' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='signature w-500'>&nbsp;</td>
                        <td className='signature w-250'>&nbsp;</td>
                    </tr>
                    <tr>
                        <td className='small w-500'>Signature</td>
                        <td className='small w-250'>Date</td>
                    </tr>
                    <tr>
                        <td className='signature w-187'>&nbsp;</td>
                        <td className='signature w-187'>&nbsp;</td>
                        <td className='signature w-187'>&nbsp;</td>
                        <td className='signature w-187'>&nbsp;</td>
                    </tr>
                    <tr>
                        <td className='small w-187'>Signed by: </td>
                        <td className='small w-187'>person served  </td>
                        <td className='small w-187'>guardian</td>
                        <td className='small w-187'>personal representative</td>
                    </tr>

                </table>











            </div>
        </form>

    )
}  
